import React from 'react';
import { useMsal } from '@azure/msal-react';

const UserProfile = ({ showLogoutOnly = false }) => {
  const { instance, accounts } = useMsal();

  // Function to handle logout
  const handleLogout = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: window.location.origin
    });
  };

  // Function to get user's display name from token claims
  const getUserDisplayName = () => {
    if (accounts && accounts.length > 0) {
      const account = accounts[0];
      
      // Try to get the display name from various claim sources
      return account.idTokenClaims?.name || 
             account.idTokenClaims?.given_name + ' ' + account.idTokenClaims?.family_name ||
             account.name ||
             account.idTokenClaims?.preferred_username ||
             account.username ||
             'User';
    }
    return 'User';
  };

  // Function to get user's email
  const getUserEmail = () => {
    if (accounts && accounts.length > 0) {
      const account = accounts[0];
      
      return account.idTokenClaims?.email ||
             account.idTokenClaims?.preferred_username ||
             account.username ||
             'No email available';
    }
    return 'No email available';
  };

  if (!accounts || accounts.length === 0) {
    return <div>Loading user profile...</div>;
  }

  // Show logout button only (for session expired scenario)
  if (showLogoutOnly) {
    return (
      <button 
        onClick={handleLogout}
        className="btn btn-primary"
        style={{
          fontSize: '1.1rem',
          padding: '0.75rem 2rem',
          cursor: 'pointer',
          border: 'none',
          borderRadius: '6px',
          background: '#1B394B',
          color: 'white',
          fontWeight: '500',
          transition: 'all 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = '#15313a';
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.2)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = '#1B394B';
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = 'none';
        }}
      >
        Sign Out and Sign Back In
      </button>
    );
  }

  // Normal profile display with optional logout
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
      <span style={{ fontSize: '0.9rem', color: '#6c757d' }}>
        Welcome, <strong>{getUserDisplayName()}</strong>
      </span>
      <button 
        onClick={handleLogout}
        style={{
          padding: '0.4rem 0.8rem',
          fontSize: '0.85rem',
          cursor: 'pointer',
          border: '1px solid #1B394B',
          borderRadius: '4px',
          background: 'white',
          color: '#1B394B',
          fontWeight: '500',
          transition: 'all 0.2s ease'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = '#1B394B';
          e.currentTarget.style.color = 'white';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = 'white';
          e.currentTarget.style.color = '#1B394B';
        }}
      >
        Sign Out
      </button>
    </div>
  );
};

export default UserProfile;